import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const TrialBalance = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  // const TotalDebit = useMemo(() => 
  //   responseData.reduce((acc, curr) => acc + curr.DebitAmount, 0),
  //   [],);


    const TotalDebit = responseData?.reduce((acc, curr) => {
      acc += Number(curr.DebitAmount);
      return acc;
    }, 0).toFixed(2)

    const TotalCredit = responseData?.reduce((acc, curr) => {
      acc += Number(curr.CreditAmount);
      return acc;
    }, 0);

  // const TotalCredit = useMemo(() => 
  // responseData.reduce((acc, curr) => acc + curr.CreditAmount, 0),
  //   [],
  // );




  const columns = useMemo(() => [
    {
      header: "AccountName",
      accessorKey: "AccountName",
      filterFn : "contains",
      Footer: () => (
          <Box>Total</Box>
      ),
    },
    {
      header: "DEBIT",
      accessorKey: "DebitAmount",
      filterFn : "contains",
      Cell: ({ row }) => row.original.DebitAmount == "0" || "" ? '' : row.original.DebitAmount,
      Footer: () => (
          <Box>${TotalDebit}</Box>
      ),
    },
    {
      header: "CREDIT",
      accessorKey: "CreditAmount",
      filterFn : "contains",
      Cell: ({ row }) => row.original.CreditAmount == "0" || "" ? '' : row.original.CreditAmount,
      Footer: () => (
          <Box>${TotalCredit}</Box>
      ),
    },
  ]);

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Name</th>' +
        '<th style="padding: 7px;">DEBIT</th>' +
        '<th style="padding: 7px;">CREDIT</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Name +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].DEBIT+
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CREDIT +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("TrialBalance_.pdf");
        setLoading(false);
      },
    });
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `TrialBalance_.xlsx`);
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `TrialBalance_.xlsx`);
  };

  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download
  const handleDownload = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    pdf.save("document.pdf");
  };

  // const handleDropdownChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setSelectReport(event.target.value);
  //   console.log(event.target.value);
  // };

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  // const handleStartDateChange = (momentDate) => {
  //   setStartDate(moment(momentDate).format("YYYY-MM-DD"));
  //   console.log("date",momentDate);
  // };

  // const handleEndDateChange = (momentDate) => {
  //   setEndDate(moment(momentDate).format("YYYY-MM-DD"));
  // };
  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {

    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "")

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${config.reportsBaseUrl}/reports/trialbalance?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) =>({
            ...el,
            CreditAmount : Number(el.CreditAmount),
          }))
          setResponseData(FilterData);
          setData(FilterData);
          // setResponseData(res.data.ResponseData);
          // setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord)
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(()=>{
  apicall()
  },[
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ])

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    // axios
    //   .get(
    //     `${
    //       config.reportsBaseUrl
    //     }/reports/trialbalance?startdate=${""}&enddate=${""}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log("res======>", res);
    //     console.log(res.data.ResponseData);
    //     if (res.data.ResponseCode === "SUCCESS") {
    //       setResponseData(res.data.ResponseData);
    //       setData(res.data.ResponseData);
    //       console.log("11", responseData);
    //       //   barcodeRefs.current = responseData;
    //     }
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoading(false);
    //   });

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalDebit = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Debit);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalcredit = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Credit);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalCredit(sum);
  };

  useEffect(() => {
    calculateTotalDebit();
    calculateTotalcredit();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Trial Balance</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
            <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Report period
                </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
            <button
              type="submit"
              className="btn btn-primary pull-right"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}

          </div>

          {/* Receipt */}

          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">
                    Trial Balance
                  </p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6>
                    <p>
                      Date: {startdate} - {enddate}
                    </p> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="table-responsive">
                <table className="table mt-3"> */}
                  {/* <thead>
                    <tr>
                      <th style={{ textAlign: "right", width: "50%" }}>
                        DEBIT
                      </th>
                      <th style={{ textAlign: "right", width: "50%" }}>
                        <strong>CREDIT</strong>
                      </th>
                    </tr>
                  </thead> */}

                  {/* <tbody>
                    {responseData?.map((report, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ textAlign: "left" }}>
                            <br />
                            <br />
                            <small className="d-flex justify-content-start align-items-center">
                              <span className="flex-fill text-left fw-bold">
                                {report.Name}
                              </span>
                            </small>
                          </td>
                          <td>${Number(report.Debit).toFixed(2)}</td>
                          <td
                            style={{ textAlign: "right" }}
                            className="mx-5 mt-5"
                          >
                            ${Number(report.Credit).toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody> */}

                  <div>
                    {/* <MaterialReactTable
                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      columns={columns}
                      
                      data={responseData}
                      enableColumnResizing
                      enableGrouping
                      enableStickyHeader
                      enableStickyFooter
                      enableRowSelection
                      enableColumnOrdering
                      initialState={{
                        density: "compact",
                        expanded: true, //expand all groups by default
                        // grouping: [""], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 25 },
                        sorting: [{ id: "state", desc: false }], //sort by state by default
                      }}
                      // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                      // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                      muiPaginationProps={{
                        rowsPerPageOptions: [25, 50, 100, 300, 500],
                      }}
                      // manualFiltering
                      manualPagination
                      manualSorting
                      // muiToolbarAlertBannerProps={
                      //   isError
                      //     ? {
                      //         color: "error",
                      //         children: "Error loading data",
                      //       }
                      //     : undefined
                      // }
                      
                      muiTableBodyProps={{
                        sx: () => ({
                          "& tr:nth-of-type(even)": {
                            backgroundColor:
                              "var(--datatable-row-background-color)",
                            //'rgb(237 237 233 / 63%)'
                          },
                          "& td": {
                            borderRight:
                              "1px solid var(--datatable-row-background-hover-color)",
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },

                          "& tr": {
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
                        }),
                      }}
                      muiTableHeadCellProps={{
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiToolbarAlertBannerProps={
                        // isError
                        // ? {
                        //   color: "error",
                        //   children: "Error loading data",
                        // }
                        // : undefined
                        {
                          isError: () => ({
                            color: "error",
                            children: "Error loading data",
                          }),
                          sx: (theme) => ({
                            background: "var(--datatable-row-background-color)", //'#e9e9e9',
                            lineHeight: "16px",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          }),
                        }
                      }
                      muiSelectCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiSelectAllCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      onColumnFiltersChange={setColumnFilters}
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onSortingChange={setSorting}
                      rowCount={rowCount}
                      state={{
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                      
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                        sx={{
                          display: "flex",
                          gap: "0.3rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          // size="small"
                          className="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={onBtExport}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Excel
                        </Button>
                        <Button
                          // size="small"
                          className="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleExportRows(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Excel
                        </Button>
                        <Button
                          // size="small"
                          className="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={() =>
                            downloadPDF(
                              "",
                              "alldata",
                              table.getVisibleFlatColumns()
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Pdf
                        </Button>
                        <Button
                          // size="small"
                          className="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            downloadPDF(
                              table.getSelectedRowModel().rows,
                              "selectedrow"
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Pdf
                        </Button>
                      </Box>
                      )}
                    /> */}

<CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Trial Balance Report"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                />
                    
                  </div>
                  
                {/* </table> */}

                {/* <div style={{ textAlign: "right" }} className="mx-5 mt-5">
                  <h6>Total Amount: ${Number(totalSum).toFixed(2)}</h6>
                  <hr
                    style={{
                      display: "inline-block",
                      borderBottom: "3px solid black",
                      width: "30%",
                    }}
                  />
                </div> */}
                {/* <hr /> */}
              {/* </div> */}
              {/* <div className="row">
                <div className="col-md-12 text-center mt-1">
                  <p>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default TrialBalance;
